import { connect } from 'react-redux';

import { isShibbolethUser, userHasRegistration } from '@Containers/Header/HeaderComponentSelectors';
import { openRegisterDialog as openRegisterDialogAction, goToLogin as goToLoginAction } from '@Containers/Header/HeaderComponentActions';
import PropTypes from 'prop-types';
import NotAnonShibbolethLogin from './NotAnonShibbolethLogin';

function NotAnonShibbolethLoginContainer(props) {
  const { openRegisterDialog, goToLogin } = props;

  const onRegisterClick = (...args) => {
    openRegisterDialog(...args);
  };

  const onSignInClick = (...args) => {
    goToLogin(...args);
  };

  return <NotAnonShibbolethLogin {...props} onRegisterClick={onRegisterClick} onSignInClick={onSignInClick} />;
}

function mapStateToProps(state) {
  return {
    isShibbolethUser: isShibbolethUser(state),
    userHasRegistration: userHasRegistration(state),
  };
}

const mapDispatchToProps = {
  openRegisterDialog: openRegisterDialogAction,
  goToLogin: goToLoginAction,
};

NotAnonShibbolethLoginContainer.propTypes = {
  openRegisterDialog: PropTypes.func,
  goToLogin: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotAnonShibbolethLoginContainer);
